module.exports = __webpack_public_path__ + "static/media/Base_Build_Up_Non_Permeable_Concrete.84bb5b65.pdf";